export default {
    failed: 'Action failed',
    success: 'Action was successful',
    // Common
    commonInfo: 'Common information',
    contactInfo: 'Contact information',
    linkedTelegramAccount: 'Linked telegram account',
    loading: 'Loading',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    error: 'Error',
    invalidCharacters: 'Invalid characters detected',
    required: 'Required',
    search: 'Search',
    // Auth
    login: 'Login',
    password: 'Password',
    signIn: 'Sign in',
    signUp: 'Sign up',
    logout: 'Logout',
    registration: 'Registration',
    confirmPassword: 'Confirm password',
    email: 'Email',
    name: 'Name',
    verificationCode: 'Verification code',
    verify: 'Verify',
    linkTelegramFirst: 'Please link your Telegram account first.',
    // Header
    profile: 'Profile',
    settings: 'Settings',
    confirmAction: 'Confirm your action',
    // Dashboard
    farms: 'Farms',
    users: 'Users',
    newFarm: 'New farm',
    addNewFarm: 'Add new farm',
    farm: 'Farm',
    noFarms: 'No farms found',
    // Farm
    farmName: 'Farm name',
    description: 'Description',
    token: 'Token',
    mainSettings: 'Main settings',
    deleteFarm: 'Delete farm',
    deleteFarmConfirm: 'Delete farm?',
    yesDeleteFarm: 'Yes, delete this farm',
    withToken: 'with token',
    willBeDeleted: 'will be deleted',
    farmCreated: 'Farm has been created',
    farmUpdated: 'Farm has been updated',
    farmDeleted: 'Farm has been deleted',
    // Devices
    devices: 'Devices',
    miners: 'Miners',
    servers: 'Servers',
    apps: 'Apps',
    online: 'Online',
    offline: 'Offline',
    total: 'Total',
    noConnectedMiners: 'No connected miners',
    noRegisteredApps: 'No registered apps',
    user: 'User',
    dashboard: 'Dashboard',
    // Farm Page
    connect: 'Connect',
    ipRanges: 'IP Ranges',
    network: 'Network',
    advancedSettings: 'Advanced settings',
    tune: 'Tune',
    chainManagement: 'Chain management',
    schedule: 'Schedule',
    server: 'Server',
    notSelected: 'Not selected',
    minerType: 'Miner type',
    boardType: 'Board type',
    selectMinerType: 'Select miner type',
    hashrate: 'Hashrate',
    selected: 'Selected',
    // Commands
    start: 'Start',
    stop: 'Stop',
    restart: 'Restart',
    reboot: 'Reboot',
    revertStock: 'Revert stock',
    factoryDefault: 'Factory default',
    blink: 'Blink',
    minerSettings: 'Miner settings',
    changePassword: 'Change password',
    poolsInfo: 'Pools info',
    serialNumber: 'Serial number',
    cloud: 'Cloud',
    scanNetwork: 'Scan network',
    updateFirmware: 'Update firmware',
    // Dialogs
    noMinersSelected: 'No miners selected',
    selectOneMiner: 'Select one miner',
    confirmYourAction: 'Confirm your action',
    confirm: 'Confirm',
    actionCompleted: 'Action completed',
    startMiners: 'Start miners',
    stopMiners: 'Stop miners',
    restartMiners: 'Restart miners',
    rebootMiners: 'Reboot miners',
    updateFirmwareQuestion: 'Update firmware?',
    // Users Page
    addNewUser: 'Add new user',
    noUsers: 'No users',
    group: 'Group',
    mail: 'Mail',
    active: 'Active',
    notActive: 'Not active',
    id: 'ID',
    deleteUser: 'Delete user',
    userDeleted: 'User has been deleted',
    ok: 'OK',
    clusterId: 'Cluster ID',
    changeRole: 'Change role',
    roleId: 'Role',
    roleSuperAdmin: 'SuperAdmin',
    roleAdmin: 'Admin',
    roleManager: 'Manager',
    roleUser: 'User',
    confirmRoleChange: 'Change user role to {role}?',
    roleUpdated: 'User role updated',
    // Admin Settings
    adminSettings: 'Admin Settings',
    telegramBotSettings: 'Telegram Bot Settings',
    telegramBotUsername: 'Bot Username',
    telegramBotUsernameHint: "Username without the {'@'} symbol (e.g. MyBot)",
    telegramBotToken: 'Bot Token',
    telegramBotTokenHint: 'Token from BotFather',
    testConnection: 'Test Connection',
    settingsSaved: 'Settings saved successfully',
    settingsSaveFailed: 'Failed to save settings',
    telegramConnectionSuccess: 'Connection successful! Bot is working.',
    telegramConnectionFailed: 'Connection failed. Check token.',
    botStatus: 'Bot Status',
    botName: 'Bot Name',
    botUsername: 'Bot Username',
    // Clusters
    clusters: 'Clusters',
    currentClusterId: 'Current cluster ID',
    searchClusters: 'Search clusters',
    orderBy: 'Order by',
    asc: 'ASC',
    desc: 'DESC',
    addCluster: 'Add cluster',
    frontUrl: 'Front URL',
    clusterType: 'Cluster type',
    actions: 'Actions',
    noClusters: 'No clusters',
    clustersLoadFailed: 'Failed to load clusters',
    deleteClusterConfirm: 'Delete this cluster?',
    clusterDeleted: 'Cluster has been deleted',
    clusterCreated: 'Cluster has been created',
    clusterUpdated: 'Cluster has been updated',
    clusterSettings: 'Cluster settings',
    confirmUrl: 'Confirmation URL',
    mailer: 'Mailer',
    mailerService: 'Service',
    mailerServiceHint: 'Leave empty to configure via host',
    host: 'Host',
    port: 'Port',
    secureConnection: 'Secure connection',
    mailerUser: 'User',
    mailerPassword: 'Password',
    mailerFrom: 'From',
    telegram: 'Telegram',
    telegramBot: 'Telegram bot',
    clusterSettingsSaved: 'Cluster settings saved',
    newCluster: 'New cluster',
    createCluster: 'Create cluster',
    editCluster: 'Edit cluster',
    accessDenied: 'Access denied',
    // Profile
    profileTitle: 'Profile',
    newPasswordLabel: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    linkTelegramAccount: 'Link Telegram Account',
    unlinkTelegramAccount: 'Unlink Telegram Account',
    telegramLinkTitle: 'Link Telegram Account',
    telegramLinkDescription: 'Follow this link to link your Telegram account:',
    copyLink: 'Copy Link',
    downloadQRCode: 'Download QR Code',
    scanQRCode: 'Or scan this QR code:',
    qrCodeHint: 'You can take a photo of this QR code with your phone\'s camera.',
    profileUpdated: 'Profile updated successfully',
    profileUpdateFailed: 'Failed to update profile',
    passwordsDoNotMatch: 'Passwords do not match',
    telegramLinked: 'Telegram account linked successfully',
    telegramUnlinked: 'Telegram account unlinked successfully',
    telegramLinkFailed: 'Failed to create Telegram link',
    telegramUnlinkFailed: 'Failed to unlink Telegram account',
    noTelegramLinked: 'No Telegram account linked',
    telegramNotConfigured: 'Telegram bot is not configured. Please contact administrator.',
    confirmUnlink: 'Confirm Unlink',
    confirmUnlinkMessage: 'Are you sure you want to unlink the Telegram account',
    unlink: 'Unlink',
    linkCopied: 'Link copied to clipboard',
    phone: 'Phone',
    telegramUsername: 'Telegram Account',
    telegramUsernameHint: "Username without the {'@'} symbol (e.g. johndoe)",
    phoneHint: 'Phone number with country code',
    // Messages
    pleaseWait: 'Please wait...',
    invalidLink: 'Invalid confirmation link',
    confirmationFailed: 'Confirmation failed. Please try again.',
    backToLogin: 'Back to login',
    emailSent: 'The letter has been sent. Check your email to confirm registration.',
    // Password Reset
    forgotPassword: 'Forgot password',
    forgotPasswordHint: 'Enter your email address and we will send you a link to reset your password.',
    sendResetLink: 'Send reset link',
    resetLinkSent: 'If an account with this email exists, we have sent a password reset link.',
    resetPassword: 'Reset password',
    newPassword: 'New password',
    passwordMinLength: 'Password must be at least 4 characters',
    passwordsMustMatch: 'Passwords must match',
    passwordResetSuccess: 'Your password has been reset successfully. You can now sign in with your new password.',
    invalidResetLink: 'Invalid or expired reset link',
    tryAgain: 'Try again',
    connectionError: 'Failed to connect to server',
    requestFailed: 'Request failed. Please try again.',
    resetFailed: 'Password reset failed. The link may have expired.',
    // Settings
    alarmNotifications: 'Alarm Notifications',
    telegramAlarms: 'Telegram',
    alarmsSentTo: 'Alarms will be sent to',
    telegramNotLinked: 'Telegram account is not linked',
    alarms: {
        new_device: 'Device added',
        device_removed: 'Device removed',
        device_online: 'Device is online',
        device_offline: 'Device is offline',
        device_pools_changed: 'Device pools changed',
        chip_temperature_gt: 'Chip temperature is higher than',
        board_temperature_gt: 'Board temperature is higher than',
        efficiency_lt: 'Efficiency is lower than',
        power_consumption_gt: 'Power consumption is higher than',
        power_consumption_lt: 'Power consumption is less than',
    }
};
